// AboutOne component - Converted from components/AboutOne.vue
// About section with images and content
import React from 'react';
import { Link } from 'react-router-dom';
import aboutImg1 from '../assets/images/about/about-1-img-1.png';
import aboutImg2 from '../assets/images/about/about-1-img-2.png';
import leafImg from '../assets/images/resources/leaf.png';

const AboutOne: React.FC = () => {
  return (
    <section className="about_one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="about1_img wow fadeInUp" data-wow-delay="200ms">
              <div className="about1_shape_1"></div>
              <img src={aboutImg1} alt="About-Img" />
              <div className="about1_icon-box">
                <div className="circle">
                  <span className="icon-focus"></span>
                </div>
              </div>
              <div className="about_img_2">
                <img src={aboutImg2} alt="Secondary about image" />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="block-title text-left wow fadeInUp" data-wow-delay="300ms">
              <p>Services Leaders Agro Elite</p>
              <h3 style={{fontSize: '2.5rem',marginTop: '15px'}}>Experts en solutions agricoles innovantes</h3>
              <div className="leaf">
                <img src={leafImg} alt="Decorative leaf" />
              </div>
            </div>
            <div className="about_content">
              <div className="text">
                <p>
                  Leaders Agro Elite transforme l&apos;agriculture en Tunisie avec des pratiques
                  durables et des solutions innovantes adaptées aux défis locaux. Nos experts
                  offrent des conseils personnalisés, des solutions de gestion et un soutien
                  technique pour optimiser vos récoltes.
                </p>
              </div>
              <div className="about1_icon_wrap">
                <div className="about1_icon_single">
                  <div className="about1_icon">
                    <span className="icon-harvest"></span>
                  </div>
                  <p>
                    Culture de
                    <br />
                    céréales
                  </p>
                </div>
                <div className="about1_icon_single">
                  <div className="about1_icon">
                    <span className="icon-temperature"></span>
                  </div>
                  <p>
                    Production d&apos;olives
                  </p>
                </div>
              </div>
              <div className="bottom_text">
                <p>
                  Nous offrons des services agricoles personnalisés pour optimiser vos récoltes
                  et assurer la prospérité de votre exploitation.
                </p>
              </div>
              <div className="about1__button-block">
                <Link to="/about" className="thm-btn about_one__btn">
                  Plus d&apos;informations
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOne;
